import { createUseStyles } from 'react-jss'

const useAdvancedAudienceTargetingSectionStyles = createUseStyles({
  sectionTitle: {
    marginBottom: 30
  },
  subsection: {
    marginBottom: 30
  },
  genderCheckboxes: {
    display: 'flex',
    gap: 60
  },
  genderCheckbox: {
    marginTop: [0, '!important'],
    marginLeft: [0, '!important']
  }
})

export default useAdvancedAudienceTargetingSectionStyles
